import { defineMessages } from 'react-intl';
const messages = defineMessages({
    Title: {
        id: 'CapacityPlanningReadinessTitle',
        defaultMessage: 'Capacity planning readiness report',
    },
    OverviewLead: {
        id: 'CapacityPlanningReadinessOverviewLead',
        defaultMessage: 'This checklist shows the prerequisites that must be in order before the capacity planning is reliable. Click a part for the details.',
    },
    CheckReadiness: { id: 'CapacityPlanningReadinessCheck', defaultMessage: 'Check readiness' },
    CheckAgain: { id: 'CapacityPlanningReadinessCheckAgain', defaultMessage: 'Check again' },
    BackToWizard: {
        id: 'CapacityPlanningReadinessBackToWizard',
        defaultMessage: 'Back to the capacity planning wizard',
    },
    Checking: {
        id: 'CapacityPlanningReadinessChecking',
        defaultMessage: 'Checking, this can take a minute...',
    },
    Section: { id: 'CapacityPlanningReadinessSection', defaultMessage: 'Part {step}' },
    ViewDetails: { id: 'CapacityPlanningReadinessViewDetails', defaultMessage: 'View details →' },
    BackToOverview: {
        id: 'CapacityPlanningReadinessBackToOverview',
        defaultMessage: 'Back to overview',
    },
    AllOk: { id: 'CapacityPlanningReadinessAllOk', defaultMessage: 'All in order' },
    NoData: { id: 'CapacityPlanningReadinessNoData', defaultMessage: 'No data' },
    CheckedCount: { id: 'CapacityPlanningReadinessCheckedCount', defaultMessage: '{count} checked' },
    IssueCount: {
        id: 'CapacityPlanningReadinessIssueCount',
        defaultMessage: '{count} attention points',
    },
    OkCount: { id: 'CapacityPlanningReadinessOkCount', defaultMessage: '{count} in order' },
    Show: { id: 'CapacityPlanningReadinessShow', defaultMessage: 'show' },
    Hide: { id: 'CapacityPlanningReadinessHide', defaultMessage: 'hide' },
    OkLabel: { id: 'CapacityPlanningReadinessOkLabel', defaultMessage: 'In order' },
    AttentionBadge: {
        id: 'CapacityPlanningReadinessAttentionBadge',
        defaultMessage: 'Attention point',
    },
    WarningBadge: { id: 'CapacityPlanningReadinessWarningBadge', defaultMessage: 'Note' },
    TimeTablesTitle: {
        id: 'CapacityPlanningReadinessTimeTablesTitle',
        defaultMessage: 'Employee time tables',
    },
    TimeTablesIntro: {
        id: 'CapacityPlanningReadinessTimeTablesIntro',
        defaultMessage: 'A correctly set time table determines the available working hours per week for every employee. It is the basis on which the whole capacity planning is calculated: without a time table (or with a time table without working hours) no available capacity can be determined for that employee. The employees below with an attention point first need a valid time table before the capacity planning is reliable.',
    },
    TemplatesTitle: {
        id: 'CapacityPlanningReadinessTemplatesTitle',
        defaultMessage: 'Task assignment of scheduled task templates',
    },
    TemplatesIntro: {
        id: 'CapacityPlanningReadinessTemplatesIntro',
        defaultMessage: 'Task templates that are scheduled need a responsible: an assigned user (or profile) on the main task, or on all work subtasks. Without an assignment the capacity planning does not know who the planned work belongs to. Only scheduled task templates are checked here; the templates below with an attention point need an assignment.',
    },
    ScheduleTitle: {
        id: 'CapacityPlanningReadinessScheduleTitle',
        defaultMessage: 'Assignment of scheduled tasks per customer',
    },
    ScheduleIntro: {
        id: 'CapacityPlanningReadinessScheduleIntro',
        defaultMessage: 'When a task template is assigned to a profile (role), the responsible per customer is the employee filled in for that role on the customer. When that role is empty on the customer, the scheduled task has no responsible and the capacity planning for that work is unreliable. Fill in the missing role on the customers below, or assign the task directly to a user.',
    },
    UsersTitle: {
        id: 'CapacityPlanningReadinessUsersTitle',
        defaultMessage: 'Active users on customer files',
    },
    UsersIntro: {
        id: 'CapacityPlanningReadinessUsersIntro',
        defaultMessage: 'Employees can be assigned on every customer file (responsible, employee, associate…). When such an assigned employee is no longer active (out of service) or no longer exists, the capacity planning cannot assign the work of that customer correctly. The customers below have at least one assigned user who is no longer active; replace that assignment with an active employee.',
    },
    NoActiveEmployees: {
        id: 'CapacityPlanningReadinessNoActiveEmployees',
        defaultMessage: 'No active employees found.',
    },
    NoScheduledTemplates: {
        id: 'CapacityPlanningReadinessNoScheduledTemplates',
        defaultMessage: 'No scheduled task templates found.',
    },
    NoScheduledTasks: {
        id: 'CapacityPlanningReadinessNoScheduledTasks',
        defaultMessage: 'No scheduled tasks found.',
    },
    AllScheduledTasksAssigned: {
        id: 'CapacityPlanningReadinessAllScheduledTasksAssigned',
        defaultMessage: 'All scheduled tasks have a responsible.',
    },
    NoRelationsWithUsers: {
        id: 'CapacityPlanningReadinessNoRelationsWithUsers',
        defaultMessage: 'No customers with assigned users found.',
    },
    AllAssignedUsersActive: {
        id: 'CapacityPlanningReadinessAllAssignedUsersActive',
        defaultMessage: 'All assigned users are active.',
    },
    ColEmployee: { id: 'CapacityPlanningReadinessColEmployee', defaultMessage: 'Employee' },
    ColHoursPerWeek: { id: 'CapacityPlanningReadinessColHoursPerWeek', defaultMessage: 'Hours/week' },
    ColProductivity: {
        id: 'CapacityPlanningReadinessColProductivity',
        defaultMessage: 'Productivity',
    },
    ColStatus: { id: 'CapacityPlanningReadinessColStatus', defaultMessage: 'Status' },
    ColAttention: { id: 'CapacityPlanningReadinessColAttention', defaultMessage: 'Attention point' },
    ColTemplate: { id: 'CapacityPlanningReadinessColTemplate', defaultMessage: 'Task template' },
    ColWorkSubtasks: {
        id: 'CapacityPlanningReadinessColWorkSubtasks',
        defaultMessage: 'Work subtasks',
    },
    ColClient: { id: 'CapacityPlanningReadinessColClient', defaultMessage: 'Customer' },
    ColMissingRole: { id: 'CapacityPlanningReadinessColMissingRole', defaultMessage: 'Missing role' },
    ColInvalidAssignment: {
        id: 'CapacityPlanningReadinessColInvalidAssignment',
        defaultMessage: 'Invalid assignment',
    },
    NoTimeTable: { id: 'CapacityPlanningReadinessNoTimeTable', defaultMessage: 'No time table set' },
    TimeTableWithoutHours: {
        id: 'CapacityPlanningReadinessTimeTableWithoutHours',
        defaultMessage: 'Time table without working hours',
    },
    ProductivityNotSet: {
        id: 'CapacityPlanningReadinessProductivityNotSet',
        defaultMessage: 'Productivity not set',
    },
    NoUserOnMainOrWorkSubtasks: {
        id: 'CapacityPlanningReadinessNoUserOnMainOrWorkSubtasks',
        defaultMessage: 'No assigned user on the main task or work subtasks',
    },
    MissingAssignment: {
        id: 'CapacityPlanningReadinessMissingAssignment',
        defaultMessage: 'Missing assignment on the task template',
    },
    InactiveUser: {
        id: 'CapacityPlanningReadinessInactiveUser',
        defaultMessage: '{role}: {name} (no longer active)',
    },
    UnknownUser: {
        id: 'CapacityPlanningReadinessUnknownUser',
        defaultMessage: '{role}: unknown or removed user',
    },
    UnknownUserName: {
        id: 'CapacityPlanningReadinessUnknownUserName',
        defaultMessage: 'Unknown or removed user',
    },
    NoLongerActive: {
        id: 'CapacityPlanningReadinessNoLongerActive',
        defaultMessage: 'no longer active',
    },
    Customers: { id: 'CapacityPlanningReadinessCustomers', defaultMessage: '{count} customers' },
    SearchCustomer: {
        id: 'CapacityPlanningReadinessSearchCustomer',
        defaultMessage: 'Search on customer...',
    },
    OpenTaskTemplates: {
        id: 'CapacityPlanningReadinessOpenTaskTemplates',
        defaultMessage: 'Open task templates',
    },
});
export default messages;
